<template>
  <div>
    <el-form class="serach-form" :inline="true" :model="filters" size="small">
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.deptId"
          placeholder="学院名称"
        >
          <el-option
            v-for="(item, i) in applicableOrganizations"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.leaderType"
          placeholder="管理主体"
        >
          <el-option
            v-for="(item, i) in managementMainBodies"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="m-l-14">
        <butn btntype="primary" title="查询" @click="query"></butn>
        <butn title="重置" @click="reset" class="czButn"></butn>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import butn from "@/components/button/index";
import { clearObject } from "@/utils/common.js";
export default {
  components: { butn },
  props: {
    applicableOrganizations: {
      type: Array,
      default: () => [],
    },
    managementMainBodies: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      filters: {},
    };
  },
  created() {},
  methods: {
    query() {
      this.$emit("search", clearObject({ ...this.filters }));
    },
    reset() {
      this.filters = {};
      this.query();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>